export default "__VITE_ASSET__DKzVUpt___"